import * as React from 'react';
import { useSelector } from 'react-redux';
import { GenericService } from '../GenericService';
import { SearchResultPosition } from '../../../components';
import { IService } from '../../types';
import { DeprecatedBetInput as BetInput } from '../../../../BetInput/DeprecatedBetInput';
import { useAuctionState } from '../../../../BetInput/hooks/useAuctionState';
import { selectBaseAuctionBetByServiceId } from '../../../../../../../../../selectors/auction';
import { ServicePrice } from '../ServicePrice';
import { getTopBetServiceTitle } from './utils';
import { selectTopAuctionBetPosition } from '../../../../../../../../../selectors/betPosition';
import * as styles from './TopService.css';

export const TopService = ({ selected, blurred, onSelect, disabled, type }: IService) => {
  const topAuctionBetPosition = useSelector(selectTopAuctionBetPosition);
  const price: number = useSelector(selectBaseAuctionBetByServiceId(type));

  const { currentBet, hasNextBet, hasPreviousBet, loading, showBetInput, updateBet, decreaseBet, increaseBet } =
    useAuctionState();

  const topBetServiceTitle = getTopBetServiceTitle(currentBet, price);

  return (
    <GenericService
      title={topBetServiceTitle}
      subtitle="Максимум звонков"
      serviceType={type}
      className={styles.root}
      selected={selected}
      blurred={blurred}
      disabled={disabled}
      footer={
        <SearchResultPosition
          place={topAuctionBetPosition}
          color={selected ? 'primary_100' : 'fill_secondary_active_30'}
        />
      }
      onSelect={onSelect}
    >
      {showBetInput ? (
        <div className={styles.input}>
          <BetInput
            disabled={disabled}
            previousDisabled={!hasPreviousBet}
            suffix="₽/день"
            value={currentBet}
            loading={loading}
            nextDisabled={!hasNextBet}
            onNextClick={increaseBet}
            onPreviousClick={decreaseBet}
            onChange={updateBet}
          />
        </div>
      ) : (
        <ServicePrice price={price} suffix="₽/день" />
      )}
    </GenericService>
  );
};
